/**
 * Shared dispute lifecycle — single source for Resume, Dispute Center, eligibility.
 * Mirrors backend/services/dispute_lifecycle.py
 */

export const WIZARD_STEPS = [
  { key: 'select_items', name: 'Item Selection', order: 1 },
  { key: 'ai_review', name: 'AI Review', order: 2 },
  { key: 'letter_generation', name: 'Letter Generation', order: 3 },
  { key: 'preview', name: 'Letter Preview', order: 4 },
  { key: 'supporting_documents', name: 'Supporting Documents', order: 5 },
  { key: 'envelope_setup', name: 'Envelope Setup', order: 6 },
  { key: 'send', name: 'Send Mail', order: 7 },
  { key: 'completed', name: 'Completed', order: 8 },
];

export const WIZARD_STEP_LABELS = Object.fromEntries(
  WIZARD_STEPS.map((s) => [s.key, s.name])
);

export const WIZARD_STEP_ROUTES = {
  select_items: '/dispute-wizard/factual/select-items',
  ai_review: '/dispute-wizard/factual/select-items',
  letter_generation: '/dispute-wizard/factual/preview',
  preview: '/dispute-wizard/factual/preview',
  supporting_documents: '/dispute-wizard/final-package',
  envelope_setup: '/dispute-wizard/step7-envelope',
  send: '/dispute-wizard/step8-send',
  completed: '/disputes',
};

export const TERMINAL_ROUND_STATUSES = new Set([
  'sent', 'delivered', 'cancelled', 'closed', 'resolved', 'superseded',
  'completed', 'escalated',
]);

export function normalizeStatus(value) {
  return String(value || '').trim().toLowerCase();
}

export function stepOrder(stepKey) {
  const step = WIZARD_STEPS.find((s) => s.key === normalizeStatus(stepKey));
  return step?.order || 0;
}

export function buildProgressChecklist(currentStep) {
  const currentOrder = stepOrder(currentStep);
  return WIZARD_STEPS.filter((s) => s.key !== 'completed').map((step) => {
    let state = 'upcoming';
    if (step.order < currentOrder) state = 'complete';
    else if (step.order === currentOrder) state = 'current';
    return { ...step, state };
  });
}

export function isRoundResumable(candidate) {
  if (!candidate) return false;
  if (candidate.is_completed) return false;
  return candidate.is_resumable !== false;
}
